module.exports = __webpack_public_path__ + "47363fc153a87504915bfcaf7b2a15dc.png";